import { jsx as _jsx } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import { useBreakpoints } from 'frontend/js/modules/infra/dls/hooks/use-get-breakpoints';
import { Button } from 'frontend/js/modules/infra/dls/components/button/button';
import { usePortalNode } from '../../../../hooks/use-portal-node';
export var TurnOffButton = function () {
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var mobileNode = usePortalNode('mobile-bottom-bar-portal');
    var desktopNode = usePortalNode('desktop-header-button-portal');
    var handleTurnOffCampaign = function () {
        // TODO: Implement functionality
    };
    if (isMobileOrSmaller) {
        if (!mobileNode) {
            return null;
        }
        return createPortal(_jsx(Button, { variant: "primary", size: "default", onClick: handleTurnOffCampaign, fullWidth: true, children: "Turn off campaign" }), mobileNode);
    }
    if (!desktopNode) {
        return null;
    }
    return createPortal(_jsx(Button, { variant: "primary", size: "default", onClick: handleTurnOffCampaign, children: "Turn off campaign" }), desktopNode);
};
